import { render, staticRenderFns } from "./MobilePreviewHeader.vue?vue&type=template&id=35967c94&scoped=true&"
import script from "./MobilePreviewHeader.vue?vue&type=script&lang=ts&"
export * from "./MobilePreviewHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MobilePreviewHeader.vue?vue&type=style&index=0&id=35967c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35967c94",
  null
  
)

export default component.exports